// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-OrderMessage__wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/OrderMessage/OrderMessage.scss
// module id = 934
// module chunks = 0